import { z } from "zod";
import { computeMinutesFromHours } from "../../../../../common/utils/cargaHorariaUtils";

/**
 * CopyTreinamentoSchema
 */

export const CopyTreinamentoSchema = z.object({
  nome: z.string(),
  versao: z.string(),
  cargaHoraria: z.string().default('').transform(x => computeMinutesFromHours(x)),
});

/**
 * CopyTreinamentoForm
 */

export type CopyTreinamentoForm = z.infer<typeof CopyTreinamentoSchema>;